import BaseAPI, { MAX_LIST_LIMIT, querySuffix } from "./BaseAPI";
import { complaintRoute } from "../routes";

export default class ComplaintAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, complaintRoute, "complaint");
    }

    async Create(data) {
        const result = await this._request("post", this._url(), data);
        this._emit("create", result.id);
        return result;
    }

    async List(params = {}) {
        return super.List({ limit: MAX_LIST_LIMIT, ...params });
    }

    async ListForSupplier(params = {}) {
        return this._request("get", this._url(`/supplier${querySuffix({ limit: MAX_LIST_LIMIT, ...params })}`));
    }

    async GetByIDForSupplier(id) {
        return this._request("get", this._url(`/supplier/${id}`));
    }
}
